/* RevRunners purchase-button loading artwork.
 * Observe Flow's existing spinner state; never submit forms, alter disabled
 * states, or change cart requests, availability or order acknowledgements.
 */
(function () {
  'use strict';
  if (window.__rrCartWheelLoader) { window.__rrCartWheelLoader.scan(document); return; }

  const buttonSelector = 'button[name="add"],button.product--add-to-cart-button,button.quick-add-button,.product-card-basic__add-button button';
  const spinnerSelector = 'svg[data-loading-icon],svg.spin';
  const states = new WeakMap(), pending = new Set();
  let frame = 0;
  const artwork = '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">' +
    '<circle cx="16" cy="16" r="13" stroke-width="1.8"/>' +
    '<circle cx="16" cy="16" r="10.5" stroke-width="1" opacity=".65"/>' +
    '<path d="M16 5.5v7.7M26 12.75l-7.35 2.4M22.17 24.5l-4.53-6.23M9.83 24.5l4.53-6.23M6 12.75l7.35 2.4" stroke-width="1.8"/>' +
    '<circle cx="16" cy="16" r="2.8" stroke-width="1.5"/>' +
    '<circle cx="16" cy="16" r=".9" fill="currentColor" stroke="none"/>' +
    '</g>';

  function eligible(button) {
    return button instanceof HTMLButtonElement && !button.closest('.shopify-payment-button,shopify-accelerated-checkout') &&
      !button.classList.contains('shopify-payment-button__button');
  }
  function visibleSpinner(icon, button) {
    for (let node = icon; node && node !== button; node = node.parentElement) {
      if (node.hidden || node.classList.contains('hidden')) return false;
      const style = getComputedStyle(node);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
    }
    return true;
  }
  function markBusy(button, busy) {
    let state = states.get(button);
    if (!state) { state = {busy:false, aria:null}; states.set(button, state); }
    if (busy) {
      if (!state.busy) state.aria = button.getAttribute('aria-busy');
      if (button.getAttribute('aria-busy') !== 'true') button.setAttribute('aria-busy', 'true');
      button.setAttribute('data-rr-wheel-busy', 'true');
    } else {
      button.removeAttribute('data-rr-wheel-busy');
      if (state.busy && button.getAttribute('aria-busy') === 'true') {
        if (state.aria === null) button.removeAttribute('aria-busy');
        else button.setAttribute('aria-busy', state.aria);
      }
    }
    state.busy = busy;
  }
  function update(button) {
    if (!button.isConnected || !eligible(button)) return;
    const icons = [...button.querySelectorAll(spinnerSelector)];
    let label = button.querySelector('[data-rr-wheel-label]');
    if (!icons.length) {
      markBusy(button, false);
      button.removeAttribute('data-rr-wheel-managed');
      if (label) label.remove();
      return;
    }
    button.setAttribute('data-rr-wheel-managed', '');
    for (const icon of icons) {
      if (!icon.hasAttribute('data-rr-cart-wheel')) {
        // Keep the exact SVG node and its hidden class/data-loading-icon hook.
        // Flow caches this node when it starts and finishes a cart request.
        icon.setAttribute('viewBox', '0 0 32 32');
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
        icon.setAttribute('data-rr-cart-wheel', '');
        icon.innerHTML = artwork;
      }
    }
    const busy = icons.some(icon => visibleSpinner(icon, button));
    if (busy && !label) {
      label = document.createElement('span');
      label.setAttribute('data-rr-wheel-label', '');
      label.textContent = 'Adding\u2026';
      button.append(label);
    }
    if (label && label.hidden === busy) label.hidden = !busy;
    markBusy(button, busy);
  }
  function flush() {
    frame = 0;
    const buttons = [...pending]; pending.clear();
    buttons.forEach(update);
  }
  function queue(button) {
    if (!eligible(button)) return;
    pending.add(button);
    if (!frame) frame = requestAnimationFrame(flush);
  }
  function scan(root) {
    if (root instanceof Element) {
      if (root.matches(buttonSelector)) queue(root);
      else queue(root.closest(buttonSelector));
    }
    root.querySelectorAll?.(buttonSelector).forEach(queue);
  }
  const observer = new MutationObserver(changes => {
    for (const change of changes) {
      const target = change.target instanceof Element ? change.target : change.target.parentElement;
      if (target?.hasAttribute('data-rr-wheel-label')) continue;
      if (target) queue(target.closest(buttonSelector));
      for (const node of change.addedNodes || []) if (node.nodeType === 1) scan(node);
    }
  });
  // These are the state hooks used by the native theme. Our data attributes
  // and aria-busy are deliberately excluded to avoid observation loops.
  observer.observe(document.documentElement, {
    subtree:true, childList:true, attributes:true,
    attributeFilter:['class','hidden','style']
  });
  window.__rrCartWheelLoader = {scan};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once:true});
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  window.addEventListener('pageshow', () => scan(document));
})();
